

































































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import BaseVue from "./base";
import {
  Question,
  QuestionMatrixDropdownRenderedCell,
  CssClassBuilder,
} from "survey-core";
import { getComponentName } from "./question";

@Component
export class MatrixDropdownCellComp extends BaseVue {
  @Prop() question: Question;
  @Prop() cell: QuestionMatrixDropdownRenderedCell;

  isVisible: boolean = false;
  getComponentName(element: Question | any) {
    return getComponentName(element);
  }
  getModel() {
    if(this.cell.hasQuestion) {
      return this.cell.question;
    }
    if(!!this.cell.column) {
      return this.cell.column;
    }
    return null as any;
  }
  getRequiredText(): string {
    return this.cell.requiredText;
  }
  getCellStyle() {
    if (!!this.cell.width || !!this.cell.minWidth)
      return { width: this.cell.width, minWidth: this.cell.minWidth };
    return null;
  }
  getCellIndex(): string {
    return (this.cell as any).index || "";
  }
  mounted() {
    if (!this.cell.hasQuestion || !this.question || !this.question.survey) return;
    this.onVisibilityChanged();
    this.cell.question.registerPropertyChangedHandlers(["isVisible"], () => {
      this.onVisibilityChanged();
    });
    const cQ = this.cell.question;
    const el: any = this.$el;
    const options = {
      cell: this.cell.cell,
      cellQuestion: cQ,
      htmlElement: el,
      row: this.cell.row,
      column: this.cell.cell.column,
    };
    this.question.survey.matrixAfterCellRender(this.question, options);
    if (cQ) {
      cQ.afterRenderCore(el);
    }
  }
  private onVisibilityChanged() {
    this.isVisible = this.cell.question.isVisible;
  }
}

Vue.component("survey-matrixdropdown-cell", MatrixDropdownCellComp);
export default MatrixDropdownCellComp;
